
import {createContext, useState} from 'react'

const Context = createContext()

export const FlujoContextProvider = ({children}) => {
 const [allFlujos, setAllFlujos] = useState([])
 const [flujos, setFlujos] = useState([]);
 const [flujo, setFlujo] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allFlujos, setAllFlujos, flujos, setFlujos, flujo, setFlujo, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context